
export default {
  TYPE: { COMPANY: '005' },
  STATUS: { INIT: '1', CHECK_OK:'2', CHECK_NG:'3', RECHECK_OK:'4', RECHECK_NG:'5', CHANGE:'6', FINISH: '7', CANCEL: '9' }
}



// WEBPACK FOOTER //
// ./src/untils/constant.js